import { cloneElement, type JSX, type ReactElement } from 'react'

export const addTestIdToChildren = (children: ReactElement[]): ReactElement[] =>
	children.map((child: JSX.Element, idx) => {
		if (child.props && !child.props['data-testid']) {
			return cloneElement(child, {
				'data-testid': `slideshow-item-${idx}`,
			})
		}
		return child
	})
